import { Card, CircularProgress, Grid } from "@mui/material";
import React, { useEffect } from "react";
import MDBox from "../MDBox";
import MDTypography from "../MDTypography";
interface IAppLoading {
  show: boolean;
}
export default function AppLoading({ show }: IAppLoading) {
  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {};
  }, []);
  if (!show) return null;
  return (
    <MDBox
      position={"absolute"}
      display={"flex"}
      justifyContent={"center"}
      top={0}
      left={0}
      right={0}
      bottom={0}
      zIndex={9999}
      color={"primary"}
      minHeight={"100vh"}
      sx={{ backgroundColor: "#767676a1" }}
    >
      <MDBox mt={20}>
        <Card>
          <MDBox px={15} py={10}>
            <Grid container direction={"column"} alignItems={"center"}>
              <Grid item>
                <CircularProgress size={60} />
              </Grid>
              <Grid item mt={5}>
                <MDTypography>در حال بارگذاری</MDTypography>
              </Grid>
            </Grid>
          </MDBox>
        </Card>
      </MDBox>
    </MDBox>
  );
}
